import React from 'react';
import './Impressum.css'; 

function Impressum() {
  return (
    <div className='impressum-container'>
      <div className='impressum-wrapper'>
        <h1>Impressum</h1>
        <p>
          <b>Christian Treitz - Beratung - Leckageortung - Reparatur</b>
          <br></br>
          In der Steubach 14<br></br>
          57614 Woldert<br></br>
          Telefon: 0151 57889069<br></br>
          E-Mail: info@ct-leckageortung.de<br></br>
          Homepage: ct-leckageortung.de<br></br>
          <br></br>
          Geschäftsinhaber: Christian Treitz<br></br>
          Steuernummer: 32/360/61986<br></br>
          nach § 4 Abs. 3 EStG<br></br>
          <br></br>
          <br></br>
          <b>Rechtshinweis</b><br></br>
          Alle Rechte sind vorbehalten, soweit nicht ausdrücklich etwas anderes angegeben wird. Bei Zitaten wird um Quellenangabe gebeten.<br></br>
          Alle Inhalte vermitteln lediglich einen unverbindlichen Überblick über Christian Treitz. Für die Richtigkeit, Vollständigkeit oder Aktualität der Daten wird keine Gewähr übernommen. Dies betrifft auch die Hyperlinks. Änderungen oder Ergänzungen erfolgen ohne vorherige Ankündigung.<br></br>
          <br></br>
          <br></br>
          <b>Gestaltung und Web-Design</b>
          <br></br>
          Höhner Software
          </p>
        </div>
    </div>
  );
}

export default Impressum;
